import axios from 'axios';

import { userLogoutCredentialsAction } from '../redux/actions/user';
// eslint-disable-next-line import/no-named-as-default
import store from '../store';
import { parseJwt } from '../utils/helper';
import { refreshTokenRecursive } from '../routers/helpers';

const excludeRequestUrl = [
  '/admin/api/auth/refresh',
  '/auth/update-two-fa-code',
  '/auth/configuration',
  '/auth/reject',
  '/auth/check',
  '/auth/confirm-app',
  '/auth/confirm',
];

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.xsrfCookieName = '_csrf-frontend';

const instance = axios.create({
  withCredentials: true,
  baseURL: '/admin/api',
});

instance.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return;
    }

    return Promise.reject(error);
  },
);

let isRefreshing = false;
const refreshAndRetryQueue = [];
instance.interceptors.response.use(
  (response) => {
    if (response.config.url?.includes('/export-download/')) {
      return response;
    }
    return response.data;
  },
  async (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    /**
     * Ошибка Credentials
     * Делаем logout
     */
    const access_token = localStorage.getItem('access_token');
    const jwt = parseJwt(access_token);
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry && !excludeRequestUrl.includes(originalRequest?.url)) {
      if (jwt?.su) {
        store.dispatch(userLogoutCredentialsAction(null));
      } else {
        if (!isRefreshing) {
          isRefreshing = true;
          originalRequest._retry = true;
          try {
            await refreshTokenRecursive();
            refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
              instance
                .request(config)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
            });
            refreshAndRetryQueue.length = 0;
            return instance(originalRequest);
          } catch (error) {
            store.dispatch(userLogoutCredentialsAction(null));
          } finally {
            isRefreshing = false;
          }
        } else {
          return Promise.reject(error.response);
        }

        return new Promise((resolve, reject) => {
          refreshAndRetryQueue.push({ config: originalRequest, resolve, reject });
        });
      }
    }

    /**
     * Redirect login
     */
    if (error?.response?.status === 403) {
      store.dispatch(userLogoutCredentialsAction(null));
    }

    return Promise.reject(error.response);
  },
);

export default instance;
